document.addEventListener("DOMContentLoaded", () => {
  // Desktop only
  if (window.innerWidth < 990) return;

  const menus = document.querySelectorAll(
    'header details[id^="Details-HeaderMenu-"]'
  );

  menus.forEach((menu) => {
    let timeout;

    menu.addEventListener("mouseenter", () => {
      clearTimeout(timeout);
      menu.setAttribute("open", "");
    });

    menu.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        menu.removeAttribute("open");
      }, 200); // Prevents flicker
    });

    // Prevent click toggling on desktop
    const summary = menu.querySelector("summary");

    summary?.addEventListener("click", (e) => {
      if (window.innerWidth >= 990) {
        e.preventDefault();
      }
    });
  });
});